import { useI18nContext } from '../../../../context/language/use-i18n-context';
import { FC, useState } from 'react';
import { ts } from '../i18n';
import { Link, Popover } from '@nike/eds';

export interface Props {
  setIsPopoverVisible: (value: boolean) => void;
  isPopoverVisible: boolean;
}
export const MembershipLearnMore: FC = () => {
  const { i18nString } = useI18nContext();
  const [isPopoverVisible, setIsPopoverVisible] = useState<boolean>(false);
  const header = <p>{i18nString(ts.LEARN_MORE_INTRO)}</p>;
  const body = (
    <div>
      <ul>
        <li>{i18nString(ts.LEARN_MORE_SHIPPING)}</li>
        <li>{i18nString(ts.LEARN_MORE_TRIALS)}</li>
        <li>{i18nString(ts.LEARN_MORE_RETURNS)}</li>
      </ul>
    </div>
  );
  const footer = (
    <p className="no-margin">
      {i18nString(ts.LEARN_MORE_LINK)}{' '}
      <a
        href="https://www.nike.com/us/en_us/s/register"
        className="txt_color"
        target="_blank"
        rel="noreferrer"
      >
        https://www.nike.com/us/en_us/s/register
      </a>
    </p>
  );
  return (
    <>
      <div id="conEmailText" className="text--help-text" style={{ width: '100%' }}>
        {i18nString(ts.PASS_MODAL_MEMBERSHIP)}&nbsp;
        <Popover
          onClickOutside={() => setIsPopoverVisible(false)}
          isOpen={isPopoverVisible}
          headerSlot={header}
          bodySlot={body}
          footerSlot={footer}
          data-testid="popover"
          placement={'top'}
        >
          <Link
            className="txt_color"
            style={{ textDecoration: 'underline', cursor: 'pointer', width: '100%' }}
            href="#"
            onClick={() => {
              setIsPopoverVisible(!isPopoverVisible);
            }}
          >
            {i18nString(ts.PASS_MODAL_MEMBERSHIP_LEARN_MORE)}
          </Link>
        </Popover>
      </div>
    </>
  );
};
